import { Directive, inject, input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlag } from './feature-flag';
import { MmuFeatureFlagsService } from './feature-flags.service';


@Directive({
  selector: '[mmuFeatureEnabled]'
})
export class MmuFeatureEnabledDirective implements OnInit {

  readonly feature = input.required<FeatureFlag>({ alias: 'mmuFeatureEnabled' });
  protected readonly _elseTemplate = input<TemplateRef<unknown> | undefined>(undefined, {
    alias: 'mmuFeatureEnabledElse'
  });

  get enabled(): boolean {
    return this._enabled;
  }

  private _enabled = false;
  private _featureFlagService = inject(MmuFeatureFlagsService);
  private _templateRef = inject(TemplateRef);
  private _viewContainerRef = inject(ViewContainerRef);

  ngOnInit(): void {
    this._enabled = !!(this.feature() && this._featureFlagService.isFeatureEnabled(this.feature()));
    const elseTemplate = this._elseTemplate();

    if (this._enabled) {
      this._viewContainerRef.createEmbeddedView(this._templateRef);
    } else if (elseTemplate) {
      this._viewContainerRef.createEmbeddedView(elseTemplate);
    }
  }
}
